

Object.defineProperty(exports, '__esModule', { value: true });
const ua = navigator.userAgent.toLowerCase();
function isRunOnMobile() {
  return !!ua.match(/applewebkit.*mobile.*/);
}
exports.isRunOnMobile = isRunOnMobile;
function isRunOnWechat() {
  return !!ua.match(/micromessenger/i); // 微信浏览器或微信开发者工具
}
exports.isRunOnWechat = isRunOnWechat;
function isRunOnAndroid() {
  return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1; // android终端或uc浏览器
}
exports.isRunOnAndroid = isRunOnAndroid;
function isRunOnIos() {
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
}
exports.isRunOnIos = isRunOnIos;
function runOnWhichKernel() {
  return {
    trident: ua.indexOf('trident') > -1,
    presto: ua.indexOf('presto') > -1,
    webKit: ua.indexOf('applewebkit') > -1,
    gecko: ua.indexOf('gecko') > -1 && ua.indexOf('khtml') == -1,
  };
}
exports.runOnWhichKernel = runOnWhichKernel;
function runOnWhichAppleDevice() {
  return {
    iPhone: ua.indexOf('iphone') > -1,
    iPad: ua.indexOf('ipad') > -1,
  };
}
exports.runOnWhichAppleDevice = runOnWhichAppleDevice;
function isRunOnDwdApp() {
  return !!ua.match(/dianwoda/i); // 运行在点我达APP上
}
exports.isRunOnDwdApp = isRunOnDwdApp;
